/** @jsxImportSource react */
import { transformCurrentLocationData } from '@common/helpers/url';
import SearchBoxContainer from '@react/search/components/SeachBoxContainer';
import { any, bool, func, string } from 'proptypes';
import React, { useCallback } from 'react';

const LocationSearch = ({
  address,
  showSearchIcon,
  placeholder,
  include,
  invalid,
  onBlur,
  onChange,
  includeAllTypes,
  onCurrentLocation,
  types,
  disableGoogleSearch,
  isUsingDefaultCurrentLocationHandler,
  value,
  onBlurWithoutSelection,
}) => {
  const handleLocationChange = useCallback(
    (value) => {
      if (onChange && value) {
        onChange(value);
      }
    },
    [onChange]
  );

  const handleLocationTextChange = useCallback(
    (value) => {
      if (onChange && value === '') {
        onChange(null);
      }
    },
    [onChange]
  );

  const defaultCurrentLocationHandler = useCallback(
    (value) => {
      if (onChange && value) {
        if (Array.isArray(value) && value.length > 0) {
          onChange(transformCurrentLocationData(value[0]));
        } else if (typeof value === 'object') {
          onChange(transformCurrentLocationData(value));
        } else {
          onChange(value);
        }
      }
    },
    [onChange]
  );

  return (
    <SearchBoxContainer
      onLocationSearch={handleLocationChange}
      onTextChange={handleLocationTextChange}
      address={address || value?.description || ''}
      showSearchIcon={showSearchIcon}
      placeholder={placeholder}
      include={include}
      invalid={invalid}
      onBlur={onBlur}
      className='lg:!max-w-[unset]'
      includeAllTypes={includeAllTypes}
      onCurrentLocation={
        onCurrentLocation
          ? onCurrentLocation
          : isUsingDefaultCurrentLocationHandler
          ? defaultCurrentLocationHandler
          : null
      }
      types={types}
      disableGoogleSearch={disableGoogleSearch}
      onBlurWithoutSelection={onBlurWithoutSelection}
    />
  );
};

LocationSearch.propTypes = {
  onChange: func,
  address: string,
  flex: any,
  showSearchIcon: bool,
  placeholder: string,
  include: string,
  invalid: bool,
  onBlur: func,
  onBlurWithoutSelection: func,
  includeAllTypes: bool,
};

export default LocationSearch;
